(function () {
    'use strict';

    webModule.controller('MastheadController',
        [
            '$scope', 'erateSessionVarsService',
            function ($scope, erateSessionVarsService) {
                $scope.newQuoteExpanded = false;
                $scope.newRVQuoteExpanded = false
                $scope.quoteModeS = null;
                $scope.dealerVehicleType = null;
                
                $scope.openNewQuote = function () {
                    $scope.disableNew = true;
                    $scope.newQuoteExpanded = true;
                };
                $scope.closeNewQuote = function () {
                    $scope.newQuoteExpanded = false;
                };
                $scope.closeNewQuoteAndEnable = function () {
                    $scope.disableNew = false;
                    $scope.newQuoteExpanded = false;
                };
                $scope.openNewRVQuote = function () {
                    $scope.newRVQuoteExpanded = true;
                };
                $scope.closeNewRVQuote = function () {
                    $scope.newRVQuoteExpanded = false;
                };
                $scope.init = function(){
                    $scope.quoteModeS = erateSessionVarsService.getQuotingMode();
                    $scope.dealerVehicleType = erateSessionVarsService.getCurrentDealerVehicleType();
                    $scope.newQuoteExpanded = $scope.newRVQuoteExpanded = false;
                };
                $scope.init();
            }
        ]
    );
})();
